export interface IResultLayoutPopulateArgs {
  layouts: string[];
}
export class ResultLayoutEvents {
  public static populateResultLayout = 'populateResultLayout';
}



/** WEBPACK FOOTER **
 ** ./src/events/ResultLayoutEvents.ts
 **/